import { trackEvent } from "@/services/posthog.service";

export const EVENT_FILE_CREATED = "MUTATION:FILE:CREATED";
export const EVENT_FILE_UPDATED = "MUTATION:FILE:UPDATED";
export const EVENT_FILE_DELETED = "MUTATION:FILE:DELETED";
export const EVENT_FILE_REPLACED = "MUTATION:FILE:REPLACED";

type FileEventType =
  | typeof EVENT_FILE_CREATED
  | typeof EVENT_FILE_UPDATED
  | typeof EVENT_FILE_DELETED
  | typeof EVENT_FILE_REPLACED;

export const trackFileEvent = (event: FileEventType, payload: unknown) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  trackEvent(event, payload as any);
};
